import { TextCell } from "../cells";

export const jobNumberColumn = {
  width: "1fr",
  label: <TextCell>Job Number</TextCell>,
  cell: (event: { jobNumber: string }) => (
    <TextCell>{event.jobNumber}</TextCell>
  ),
};
